export class HtmlBuilder {
	constructor(ids, classes, content) {
		this.ids = ids
		this.classes = classes
		this.content = content
		this.blocks = this.buildingBlocks()
	}

	buildingBlocks() {
		return {
			PricingTableTitleBlock: {
        containerClasses: this.classes.titleContainerClasses,
        classes: this.classes.titleClasses,
      },
      PricingTablePriceBlock: {
        containerClasses: this.classes.priceContainerClasses,
        classes: this.classes.priceClasses,
      },
      PricingTableDescriptionBlock: {
        containerClasses: this.classes.descriptionContainerClasses,
        classes: this.classes.descriptionClasses,
      },
      PricingTableListBlock: {
        classes: this.classes.listClasses,
        iconClasses: this.classes.iconClasses,
        iconStyles: this.classes.iconStyles
      },
      PricingTableButtonBlock: {
        classes: this.classes.buttonClasses
      },
		}
	}

	build() {
		return `${this.featuredBlock()}
		<div class="wf-overflow-hidden ${this.classes.classes}" id="${this.ids.id}">
			${this.buildHeaderBlock()}
			${this.buildContentBlock()}
			${this.buildFooterBlock()}
		</div>`
	}

	featuredBlock() {
		if (! this.content.featured) {
			return ''
		}
		return `<div class="${this.classes.featuredContainerClasses}">
      <h2 id="${this.ids.featuredId}" class="wf-inline-block wf-relative wf-z-50 ${this.classes.featuredClasses}">${this.content.featuredText}</h2>
    </div>`
	}

	buildHeaderBlock() {
		return `<div id="${this.ids.headerId}" class="${this.classes.headerClasses}">
			${this.buildBlocks(this.content.headerBlocks)}
		</div>`
	}

	buildContentBlock() {
		return `<div id="${this.ids.contentId}" class="${this.classes.contentClasses}">
			${this.buildBlocks(this.content.contentBlocks)}
		</div>`
	}

	buildFooterBlock() {
		return `<div id="${this.ids.footerId}" class="${this.classes.footerClasses}">
			${this.buildBlocks(this.content.footerBlocks)}
		</div>`
	}

	buildBlocks(blocks) {
		return blocks.map(block => this.buildBlock(block)).join('')
	}

	buildBlock(block) {
		let componentBlock = this.blocks[block]

		if (block == 'PricingTableTitleBlock' && this.content.hasTitle) {
			return `<div class="wf-inline-block ${componentBlock.containerClasses}">
	      <h3 id="${this.ids.titleId}" class="wf-px-2 wf-py-1 ${componentBlock.classes}">${this.content.title}</h3>
	    </div>`
		}

		if (block == 'PricingTablePriceBlock') {
			let recurrency = this.content.recurrency ? `<span class="wf-ml-1 wf-text-lg wf-text-gray-600">${this.priceRecurrency(this.content.recurrency)}</span>` : ''
			return `<div class="${componentBlock.containerClasses}">
	      <h4
	      	id="${this.ids.priceId}"
	        class="wf-inline-block ${componentBlock.classes}"
	      >${this.content.price}</h4>${recurrency}
	    </div>`
		}

		if (block == 'PricingTableButtonBlock') {
			return `<a
				href="${this.content.buttonLink}"
	      class="wf-flex wf-justify-center wf-items-center wf-h-10 wf-w-full wf-text-sm ${componentBlock.classes}"
	      id="${this.ids.buttonId}"
	    >${this.content.buttonText}</a>`
		}

		if (block == 'PricingTableDescriptionBlock' && this.content.hasDescription) {
			return `<div class="${componentBlock.containerClasses}">
	      <div class="${componentBlock.classes}" id="${this.ids.descriptionId}">${this.content.description}</div>
	    </div>`
		}

		if (block == 'PricingTableListBlock' && this.content.hasList) {
			let listItems = this.content.listItems.map(listItem => `<li class="wf-my-4 wf-flex wf-items-center">
        <i class="wf-mr-2 ${componentBlock.iconClasses} ${this.content.icon} ${this.content.class}"></i>
        ${listItem.title}
      </li>`)
			return `<ul class="${componentBlock.classes}" id="${this.ids.listId}">
				${listItems.join('')}
    	</ul>`
		}
	}

	priceRecurrency(recurrency) {
		if (recurrency == 'weekly') {
			return '/wk'
		}

		if (recurrency == 'monthly') {
			return '/mo'
		}

		if (recurrency == 'yearly') {
			return '/yr'
		}
	}
}